"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageName = void 0;
__exportStar(require("../../../../lib/google/type/color_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/type/color_pb"), exports);
__exportStar(require("../../../../lib/google/type/date_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/type/date_pb"), exports);
__exportStar(require("../../../../lib/google/type/datetime_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/type/datetime_pb"), exports);
__exportStar(require("../../../../lib/google/type/dayofweek_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/type/dayofweek_pb"), exports);
__exportStar(require("../../../../lib/google/type/decimal_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/type/decimal_pb"), exports);
__exportStar(require("../../../../lib/google/type/fraction_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/type/fraction_pb"), exports);
__exportStar(require("../../../../lib/google/type/latlng_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/type/latlng_pb"), exports);
__exportStar(require("../../../../lib/google/type/localized_text_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/type/localized_text_pb"), exports);
__exportStar(require("../../../../lib/google/type/money_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/type/money_pb"), exports);
__exportStar(require("../../../../lib/google/type/postal_address_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/type/postal_address_pb"), exports);
__exportStar(require("../../../../lib/google/type/timeofday_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/type/timeofday_pb"), exports);
exports.packageName = "google.type";
//# sourceMappingURL=index.js.map